import PropTypes from "prop-types";
import React, { useState } from "react";

import { ElementVisibilityContext, ElementVisibilityProvider } from "@swa-ui/browser";

export const PlacementsVisibilityContext = React.createContext({});

/**
 * PlacementsVisibilityProvider instantiates the ElementVisibilityProvider to keep track of placements
 * that have been viewed. This component is used alongside of the PlacementsProvider to keep track of
 * viewed placements by the customers navigating through our site with a single intersection observer instance.
 */
export const PlacementsVisibilityProvider = (props) => {
  const { children } = props;
  const [viewedPlacements, setViewedPlacements] = useState([]);

  return (
    <ElementVisibilityProvider {...getProps()}>
      <ElementVisibilityContext.Consumer>
        {(contextValue) => (
          <PlacementsVisibilityContext.Provider value={getContextValue(contextValue)}>
            {children}
          </PlacementsVisibilityContext.Provider>
        )}
      </ElementVisibilityContext.Consumer>
    </ElementVisibilityProvider>
  );

  function getProps() {
    return {
      onVisible: handleVisibilityChange,
    };
  }

  function getContextValue(contextFromElementVisiblityProvider) {
    const { registerElement } = contextFromElementVisiblityProvider;

    return {
      registerPlacement: registerElement,
      viewedPlacements,
    };
  }

  function handleVisibilityChange(registeredElements) {
    setViewedPlacements(
      registeredElements.filter((registeredElement) => registeredElement.visible)
    );
  }
};
PlacementsVisibilityContext.displayName = "PlacementsVisibilityContext";

PlacementsVisibilityProvider.displayName = "PlacementsVisibilityProvider";
PlacementsVisibilityProvider.propTypes = {
  /** Content that will be rendered. */
  children: PropTypes.node.isRequired,
};
